(function(){
  var AUTOPLAY_DELAY = 4000;

  function hideBadge(){
    // Target all known Elfsight badge patterns in parent DOM
    var selectors = [
      '.eapps-widget-toolbar',
      '[class*="eapps-widget-toolbar"]',
      '[data-elfsight-widget-toolbar]',
      '.eapps-link',
      '[class*="eapps-link"]'
    ];
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){ el.style.setProperty('display','none','important'); });
    });
    // Also find by text content (last resort)
    document.querySelectorAll('a, div, span').forEach(function(el){
      if(el.children.length === 0 && el.textContent && el.textContent.includes('Free Google Reviews Widget')){
        var node = el;
        while(node && node !== document.body){
          if(node.style){ node.style.setProperty('display','none','important'); break; }
          node = node.parentElement;
        }
      }
    });
  }

  function startAutoplay(){
    // Try to click next arrow/button inside the widget area
    setInterval(function(){
      // Try visible next button (some Elfsight layouts expose arrow outside iframe)
      var nextBtn = document.querySelector(
        '.elfsight-app-0953907b-e085-485f-aedf-a718b9fdc72e ~ [class*="next"], ' +
        '[class*="eapps"] [class*="next"], ' +
        '[class*="eapps"] [aria-label*="next" i], ' +
        '.gls-reviews-widget [class*="next"]'
      );
      if(nextBtn){ nextBtn.click(); return; }
      // Try dot navigation - click next dot
      var dots = document.querySelectorAll('.gls-reviews-widget [class*="dot"], .gls-reviews-widget [class*="pagination"] > *');
      if(dots.length > 1){
        var active = Array.from(dots).findIndex(function(d){ return d.classList.toString().includes('active') || d.getAttribute('aria-current') === 'true'; });
        var next = (active + 1) % dots.length;
        dots[next].click();
      }
    }, AUTOPLAY_DELAY);
  }

  // Watch for badge appearing via MutationObserver
  var observer = new MutationObserver(function(){ hideBadge(); });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true });

  // Also run on load
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ hideBadge(); startAutoplay(); });
  } else {
    hideBadge();
    startAutoplay();
  }
  // Repeat hide every 2s for 30s in case badge loads late
  var hideTimer = setInterval(function(){ hideBadge(); }, 2000);
  setTimeout(function(){ clearInterval(hideTimer); }, 30000);
})();